module.exports = __webpack_public_path__ + "img/car-style_taxicomum.fa5657e9.svg";